module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-RegularItalic-960874103da287fa48f3db79be47c6f3.woff2";